import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-281">
      <div className="max-w-5xl mx-auto" data-id="element-282">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-283">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-8 border-green-500" data-id="element-284">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center gap-2" data-id="element-285">
              <Check className="text-green-500" size={28} data-id="element-286" />
              Who This Is For
            </h3>
            <ul className="space-y-4" data-id="element-287">
              <li className="flex items-start gap-3" data-id="element-288">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-289" />
                <span className="text-gray-700" data-id="element-290">
                  Parents and grandparents who want to ensure their family
                  values survive the next decade.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-291">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-292" />
                <span className="text-gray-700" data-id="element-293">
                  Young activists looking for a solid foundation in conservative
                  principles.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-294">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-295" />
                <span className="text-gray-700" data-id="element-296">
                  Busy patriots who prefer listening to high-quality content
                  while on the move.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-297">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-298" />
                <span className="text-gray-700" data-id="element-299">
                  Anyone who feels the media is trying to gaslight them into
                  hating their own country.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-8 border-red-500" data-id="element-300">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center gap-2" data-id="element-301">
              <X className="text-red-500" size={28} data-id="element-302" />
              Who This Is NOT For
            </h3>
            <ul className="space-y-4" data-id="element-303">
              <li className="flex items-start gap-3" data-id="element-304">
                <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-305" />
                <span className="text-gray-700" data-id="element-306">
                  Those who are comfortable with the current cultural direction.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-307">
                <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-308" />
                <span className="text-gray-700" data-id="element-309">
                  People looking for a dry, academic political lecture.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-310">
                <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-311" />
                <span className="text-gray-700" data-id="element-312">
                  Anyone unwilling to take a stand for their beliefs.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}